import './style/index.less';
import Industry from './Industry';

export default Industry;
